const loadMarker = (
  marker,
  map,
  defaultLatitude,
  defaultLongitude,
  isPathEnabled
) => {
  const latlngs = [];
  // Get latlng from first marker
  latlngs.push(marker.getLatLng());
  // You can just keep adding markers
  // From documentation http://leafletjs.com/reference.html#polyline
  // create a red polyline from an arrays of LatLng points
  const polyline = L.polyline(latlngs, { color: "red" });
  // eslint-disable-next-line new-cap
  const featureGroup = new L.featureGroup();
  marker.setLatLng(new L.LatLng(defaultLatitude, defaultLongitude), {
    draggable: "true",
  });

  featureGroup.addLayer(marker);
  if (isPathEnabled) {
    featureGroup.addLayer(polyline);
  }
  featureGroup.addTo(map);
  map.fitBounds(featureGroup.getBounds());
  const mylatlngs = [[defaultLatitude, defaultLongitude]];
  if (isPathEnabled) {
    L.featureGroup(getArrows(mylatlngs, "red", 5, map)).addTo(map);
  }
};

const initMap = (defaultLatitude, defaultLongitude, isPathEnabled) => {
  let mapObject;
  if (mapObject !== undefined) {
    mapObject.remove();
  }
  L.mapbox.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;

  const container = L.DomUtil.get("map");
  if (container != null) {
    container._leaflet_id = null;
  }

  if (defaultLatitude) {
    mapObject = L.mapbox
      .map("map")
      .setView([defaultLatitude, defaultLongitude], 5)
      .addLayer(L.mapbox.styleLayer(process.env.REACT_APP_MAPBOX_STYLE_ID));
  }
  const marker = L.marker([defaultLatitude, defaultLongitude]);

  setTimeout(() => {
    mapObject.invalidateSize();
    loadMarker(
      marker,
      mapObject,
      defaultLatitude,
      defaultLongitude,
      isPathEnabled
    );
  });
};

export default initMap;
